import React, { useState, useEffect } from 'react';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';

// custom styles
import '../../App.css';
import ArticleCard from '../../components/ArticleCard';
import ArticleFooterCard from '../../components/ArticleFooterCard';

const ArticleTwo = () => {
  // eslint-disable-next-line no-unused-vars
  const a = 1;
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop;
      // eslint-disable-next-line max-len
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll1 = `${totalScroll / windowHeight}`;

      setScroll(scroll1);
    };

    window.addEventListener('scroll', progressBarHandler);

    return () => window.removeEventListener('scroll', progressBarHandler);
  });

  return (
    <>
      <Navbar />
      <div className="md:px-28 px-5 md:py-16 py-10">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="md:text-4xl text-3xl font-medium uppercase font-trirong dark:text-white">SYSTEMS THINKING IN THE WORKPLACE.</h1>
            <span className="block font-medium text-lpgreen text-sm capitalize pt-2">4 Mins. Read</span>
          </div>
        </div>
      </div>
      <div id="progressBarContainer">
        <div id="progressBar" style={{ transform: `scale(${scroll}, 1)`, opacity: `${scroll}` }} />
      </div>
      <section className="dark:bg-kiwi">
        <div className="md:px-28 px-5 md:py-40 py-16 relative">
          <div className="relative">
            <div className="bg-white dark:bg-black md:absolute bottom-0 md:left-0 md:px-16 px-5 py-10 md:py-16">
              <div className="flex justify-between py-1">
                <h1 className="text-lg text-orange uppercase font-medium tracking-widest">Article</h1>
              </div>
              <h1 className="md:text-4xl text-2xl font-trirong font-semibold pt-3 dark:text-white uppercase hover:text-orange">
                SYSTEMS THINKING IN
                <br />
                THE WORKPLACE.
              </h1>
            </div>
            <img
              className="md:h-455px w-full object-cover"
              src="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620666313/blackboxlanding/Rectangle_53_copy_h4wtyg.png"
              alt="Drone"
            />
          </div>
        </div>
      </section>
      <section>
        <div className="md:px-28 px-5 md:py-40">
          <div>
            <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="21" cy="20.5" rx="21" ry="20.5" fill="url(#paint0_angular)" />
              <defs>
                <radialGradient id="paint0_angular" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21 20.5) rotate(90) scale(20.5 21)">
                  <stop stopColor="#FF8300" />
                  <stop offset="1" stopColor="#E6D308" />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className="md:flex justify-between md:space-y-0 space-y-8 items-center pt-4">
            <div>
              <svg width="279" height="1" viewBox="0 0 279 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.309082" x2="279" y2="0.309082" stroke="#545454" strokeWidth="0.5" />
              </svg>
            </div>
            <div>
              <p className="text-orange">4 Mins. Read</p>
              <span className="pt-5 flex uppercase space-x-6 text-coregray tracking-widest items-center">
                <span className="dark:text-gray-300">FREE.</span>
                <span className="dark:text-gray-300">3 PAGES</span>
              </span>
            </div>
          </div>
          <div>
            <h1 className="text-4xl font-trirong py-4 capitalize dark:text-white">Systems</h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              A system is a complete entity that consists of two or more parts that are
              related to each other and an environment. The human body is a system.
              The human body is made up of different parts – the head, the hands, the legs, etc.
              Without the head, the rest of the body cannot function effectively.
              The same thing goes for the hands and the legs too.
            </p>
            <h1 className="capitalize font-trirong text-24px md:pt-16 dark:text-white">Systems have three parts.</h1>
            <ul className="md:pl-5">
              <li className="text-lg list-disc mt-5 dark:text-altgrey capitalize">
                Elements
              </li>
              <li className="text-lg list-disc mt-5 dark:text-altgrey capitalize">
                Interconnection
              </li>
              <li className="text-lg list-disc mt-5 dark:text-altgrey">A Purpose</li>
            </ul>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              A workplace is a system. The elements of the workplace include
              the members of staff and the office equipment.
              The various units in the workplace are interrelated and they work
              together to achieve the goals of the company.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              There are systems all around us. The family unit is a system. The community,
              which is made up of various families, is also a system.
              The thing with systems is whatever happens to one component
              affects the other components. Let us use the body as an example.
              If you have a headache, it makes the rest of your body feel weak
              and you might be unable to do certain routine tasks.
              We can also use our ecosystem as an example.
              The depletion of the Ozone layer due to nitrogenous compounds, Chlorofluorocarbons,
              and unregulated rocket launches, has led to serious unintended consequences.
              It has affected humans, animals, the environment, and marine life.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              When we learn to view the world as a series of systems and understand our part
              within them, we can begin to make better decisions, be better teammates,
              and find various ways to be more productive in all areas of our lives.
            </p>
            <h1 className="text-4xl font-trirong pt-4 md:pt-12 pb-8 capitalize dark:text-altgrey">What then is systems thinking?</h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Systems thinking is a way of exploring and developing effective action by looking
              at connected wholes rather than separate parts. Simply put, it is a comprehensive
              approach to investigate factors and interactions that could contribute to a
              possible outcome. Systems thinking is a powerful approach to support
              evidence-based decision making and is essential to the successful delivery
              of complex projects where there are many stakeholders and many possible solutions.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Within the workplace, it helps teams to become more aware of how they are
              interacting with each other and within the team, it helps them understand
              the outcomes they are producing.
            </p>
            <h1 className="md:text-4xl text-2xl font-trirong pt-4 md:pt-12 pb-8 capitalize dark:text-altgrey">
              Systems thinking within the workplace.
            </h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Systems thinking can serve as a useful tool in the management of an organization.
              It helps explain how the different entities within an organization interact
              and make up the system. The various units within an organization work together
              toward a goal(s).
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Aside from understanding how various components work with and affect
              each other, employees who are systems thinkers also consider how their
              actions in any component can affect the system.
              In the area of supply and demand, system thinkers know when their input
              will be needed and the factors that affect demand. They also know the
              capacity of their organization to meet demand.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Feedback is a core part of systems thinking in the workplace.
              Acting on relevant feedback allows the leaders in an organization to
              come up with solutions to problems.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Business leaders, who are also system thinkers, find a way of tying the personal
              goals of the various employees to the overall goals of the company.
              That way, when an employee achieves a personal goal, it means that the company
              goal is a step closer to being achieved. System thinkers employ a management
              style that emphasizes rewarding employees’ accomplishments.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              They regularly update employees about the company’s main objectives and how
              their contributions are each individually important in the achievement of
              those objectives.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Systems thinking make it easier to spot patterns and feedback loops in the way
              employees, project teams or departments interact. A feedback loop is when you use
              customer or employee feedback to improve on your product or service offering.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              With a systems approach, you realize everything is interrelated. Each person needs
              their co-workers to achieve success. The systems style of thinking gives you the
              tools to integrate interconnectivity, creativity, and productivity
              into your workplace.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              More importantly, systems thinking turns employees into lovers of problems as they
              will now see it as an exciting opportunity. Rather than run away from problems,
              they will see these problems as potential ways to innovate
              and develop their creativity.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              No matter how large or small your organization is, it is ultimately made up of
              different parts. To address problems, you must look at the interconnected dynamics
              of the system. It helps you to come up with long-term solutions to the problems.
              Systems thinking helps your business become a more efficient one.
              Give it a shot today.
            </p>
            <h1 className="text-4xl font-trirong pt-24 capitalize dark:text-white">
              The Author(s)
            </h1>
            <div className="pt-10 md:pb-0 pb-6">
              <svg width="59" height="1" viewBox="0 0 59 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.187109" x2="59" y2="0.187109" stroke="#61686C" strokeWidth="0.2" />
              </svg>
            </div>
            <div className="md:flex md:space-x-24 md:space-y-0 space-y-8 md:pb-0 pb-10 items-center md:pt-12">
              <ArticleFooterCard
                name="Tobi Michael"
                position="Global Head of Legals LP&Co."
                imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1618305464/blackboxlanding/IMG_3066_pusvlv.jpg"
              />
              <ArticleFooterCard
                name="Oluwafemi o."
                position="chief operation officer lp&Co."
                imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620308452/blackboxlanding/Rectangle_02_okngo9.png"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="md:flex items-center">
          <div className="md:w-1/2">
            <ArticleCard
              tag="Article"
              title="System Thinking..."
              link="/blog/article/2"
              imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620739656/blackboxlanding/Rectangle_45_spgp3k.png"
            />
          </div>
          <div className="md:w-1/2">
            <ArticleCard
              tag="Article"
              title=" Impact of Women"
              link="/blog/article/3"
              imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620310381/blackboxlanding/Rectangle_25_nncksq.png"
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ArticleTwo;
